module.exports = __webpack_public_path__ + "static/media/topastuces.6a47b720.png";